module.exports = require('./normalizeCurrency')
